












































import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { DomainRegistry } from "../../../../../domain";
import { instanceOfISeedAccessible } from "../../../../../domain/developer";
import { IItem } from "../../../../../domain/document/items";
import TabSelector from "../../../../system/selectors/TabSelector.vue";
import { ModelEditableMixin, TabContainableMixin } from "../../../../system/mixins";
import { EditingDocument } from "../../../../document/editor";
import { DocumentStructureEditableMixin } from "../../../../document/editor/mixins";
import ObjectSelector from "./object/ObjectSelector.vue";
import EntityViewer from "./object/EntityViewer.vue";
import BeanEditor from "./object/BeanEditor.vue";
import ExpressionViewer from "./object/ExpressionViewer.vue";

@Component({
  components: {
    TabSelector,
    ObjectSelector,
    EntityViewer,
    BeanEditor,
    ExpressionViewer,
  }
})
export default class ObjectDebugger extends Mixins(ModelEditableMixin, TabContainableMixin, DocumentStructureEditableMixin) {
  static readonly Tabs: {[key: string]: any} = {
    entity: {
      name: "entity",
      description: "フロントエンドで扱うエンティティ。",
    },
    seed: {
      name: "seed",
      description: "バックエンドから受信したエンティティの元データ。seedを元に編集した結果でオブジェクトを再読み込みできます。",
    },
    translated: {
      name: "translated",
      description: "バックエンドへ送信するエンティティ変換データ。translatedを元に編集した結果でオブジェクトを再読み込みできます。",
    },
    expression: {
      name: "expression",
      description: "条件式・計算式のデコードされた式。",
    },
  };
  // vmのメンバでないとテンプレートからバインドできないのでフィールドとして定義.(変化しないのでリアクティブじゃなくていい.)
  readonly entityTab: any = ObjectDebugger.Tabs.entity;
  readonly seedTab: any = ObjectDebugger.Tabs.seed;
  readonly translatedTab: any = ObjectDebugger.Tabs.translated;
  readonly expressionTab: any = ObjectDebugger.Tabs.expression;

  editingSource: EditingDocument;

  @Prop()
  isDebugging: boolean;

  mounted(): void {
    this.initializeTabs();
  }

  initializeTabs(): void {
    this.tabs = [
      this.entityTab,
      this.seedTab,
      this.translatedTab,
      this.expressionTab,
    ];
    const selectedTab = Enumerable.from(this.tabs)
      .firstOrDefault(t => t === this.selectedTab);
    this.selectedTab = selectedTab
      ? selectedTab
      : this.tabs[0];
  }

  get source(): any {
    return this.editingSource
      ? this.editingSource.lastFocusedItem
      : null;
  }

  get seed(): any {
    return instanceOfISeedAccessible(this.source)
      ? this.source.seed
      : null;
  }

  get translated(): any {
    return this.source
      ? DomainRegistry.developer.getDocumentService().translateDocumentItem(this.source)
      : null;
  }

  reload(value: any): void {
    this.updateItem(this.createItem(value));
  }

  createItem(value: any): IItem {
    const result = DomainRegistry.developer.getDocumentService().reloadDocumentItem(
      value,
      this.editingSource.attributes.format.id,
      this.editingSource.currentSection.itemSetId,
      this.editingSource.source.documentId,
      this.editingSource.attributes.executionMode
    );
    result.privateId = this.source.privateId;
    (result as any).seed = this.seed;
    return result;
  }

  get formatName(): string {
    return this.editingSource.attributes.format.name;
  }
}
